<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="container">
      <titleConfig
        :title="langSet == 'cn' ? '下载中心' : 'Download Center'"
        :type="2"
      ></titleConfig>
      <div class="search-wrap flex">
        <el-select
          class="w180"
          v-model="search.project_type"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="langSet == 'cn' ? item.value : item.value_en"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          class="w255"
          v-model="search.sessionid"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in sessionListOptions"
            :key="item.id"
            :label="item.session"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-input
          class="input"
          prefix-icon="el-icon-search"
          v-model="search.keywords"
          :placeholder="
            langSet == 'cn' ? '请输入文件名称' : 'Please enter the file name'
          "
          @change="searchHandle"
        ></el-input>
        <el-button type="primary" @click="searchHandle">{{
          langSet == "cn" ? "查询" : "Search"
        }}</el-button>
        <el-button @click="resetHandle">{{
          langSet == "cn" ? "重置" : "Reset"
        }}</el-button>
      </div>
      <div class="down_list" v-loading="loading">
        <el-table :data="list" style="width: 100%" v-if="isShowPC">
          <el-table-column
            v-if="langSet == 'cn'"
            prop="title"
            label=""
            min-width="180"
          ></el-table-column>
          <el-table-column v-if="langSet == 'en'" prop="en_title" label="" min-width="180">
            <template slot-scope="scope">
              {{ scope.row.en_title ? scope.row.en_title : scope.row.title }}
            </template>
          </el-table-column>
          <el-table-column
            prop="_inputtime"
            label=""
            width="180"
            class-name="gray"
          >
          </el-table-column>
          <el-table-column prop="file_size" label="" class-name="gray">
          </el-table-column>
          <el-table-column fixed="right" label="" width="120">
            <template slot-scope="scope">
              <div class="down-btn" @click="downLoadFile(scope.row)">
                {{ langSet == "cn" ? "下载" : "Download" }}
              </div>
            </template>
          </el-table-column>
          <template #empty>
            <nodata></nodata>
          </template>
        </el-table>
        <div class="down-mobile" v-else>
          <div class="mobile-item" v-for="(item, index) in list" :key="index">
            <div class="title">
              {{ langSet == "cn" ? item.title : item.en_title }}
            </div>
            <div>{{ item._inputtime }}</div>
            <div class="size">{{ item.file_size }}</div>
            <div class="m-btn" @click="downLoadFile(item)">
              {{ langSet == "cn" ? "下载" : "Download" }}
            </div>
          </div>
        </div>
      </div>
      <div class="page_wrap flex flex_content_center">
        <el-pagination
          v-if="totals > 10"
          background
          layout="prev, pager, next"
          :total="totals"
          :page-size="10"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import nodata from "@/components/nodata.vue";
import { downloadCenter, sessionLists, getBoxOption } from "@/api/api";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    titleConfig,
    nodata,
  },
  data() {
    return {
      loading: false,
      langSet: "",
      list: [{}],
      metaData: {},
      options: [
        {
          id: "",
          value: "全部",
          value_en: "All"
        },
        { id: "6", value: "官方文件", value_en: "Official document" },
        { id: "4", value: "展商列表", value_en: "Exhibitor List" },
        { id: "5", value: "赞助方案", value_en: "Sponsorship Proposal" },
      ],
      sessionListOptions: [],
      search: {
        sessionid: "",
        project_type: "",
        keywords: "",
      },
      pageNo: 1,
      totals: 0,
      isShowPC: true,
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    this.isMobile();
    //25.9.22 获取筛选项 dxm
    //this.getBoxOptions();
    this.getSessionLists();
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (flag) {
        this.isShowPC = false;
      } else {
        this.isShowPC = true;
      }
    },
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async getSessionLists() {
      const res = await sessionLists();
      this.sessionListOptions = res.data.lists;
      this.search.sessionid = this.sessionListOptions[0].id;
      //25.9.22 获取下载列表 dxm
      this.getDownloadCenterList();
    },
    async getBoxOptions() {
      let data = {
        fieldid: "775",
      };
      const res = await getBoxOption(data);
      this.options = res.data[775];
    },
    async getDownloadCenterList() {
      this.loading = true;
      let { sessionid, project_type, keywords } = this.search;
      let data = {
        sessionid,
        project_type,
        title: this.langSet == "cn" ? keywords : "",
        en_title: this.langSet == "cn" ? "" : keywords,
        page_size: 10,
        page_no: this.pageNo,
      };
      const res = await downloadCenter(data);
      this.list = res.data.lists;
      this.totals = res.data.count;
      this.loading = false;
    },
    currentChange(e) {
      this.pageNo = e;
      this.getDownloadCenterList();
    },
    //25.9.22 文件下载 dxm
    downLoadFile(item) {
      if(this.langSet == 'cn'){
        window.location.href = item.file;
      }else{
        window.location.href = item.en_file ? item.en_file : item.file;
      }
    },
    searchHandle() {
      this.getDownloadCenterList();
    },
    resetHandle() {
      this.search = {
        sessionid: "",
        project_type: "",
        keywords: "",
      };
      this.getDownloadCenterList();
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding-top: 80px;
  min-height: 600px;
  .search-wrap {
    padding: 30px 0;
    /deep/ .w180 .el-input {
      width: 180px;
    }
    /deep/ .w255 {
      margin: 0 15px;
      .el-input {
        width: 255px;
      }
    }
    /deep/ .el-input__inner {
      height: 50px;
      line-height: 50px;
      border-radius: 8px;
    }
    /deep/ .input {
      flex: 1;
      .el-input__icon {
        font-size: 18px;
      }
    }
    /deep/ .el-button {
      width: 120px;
      height: 50px;
      font-size: 15px;
      color: #1d2379;
      margin-left: 15px;
      border-radius: 8px;
      border-color: #1d2379;
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #1d2379;
    }
  }
}
.page_wrap {
  padding: 60px 0;
}
.down_list {
  padding: 30px;
  border-radius: 40px;
  box-shadow: 0 3px 10px 0px rgba(0, 0, 0, 0.1);
  .down-btn {
    color: #555;
    cursor: pointer;
    font-size: 15px;
    width: 98px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    border-radius: 18px;
    &:hover {
      color: #fff;
      background: #004190;
      transition: all 0.5s ease-in-out;
    }
  }
}
/deep/ .el-table {
  font-size: 15px;
  color: #001a33;
  .gray {
    color: #555;
  }
}
/deep/ .el-table thead {
  display: none;
}
/deep/ .el-table .cell {
  line-height: 46px;
}
/deep/ .el-table::before,
/deep/ .el-table__fixed-right::before {
  z-index: -1;
}
@media only screen and (max-width: 767px) {
  .container {
    padding-top: 0.58rem;
    .search-wrap {
      flex-wrap: wrap;
      padding-top: 1.3rem;
      position: relative;
      margin-top: 0.58rem;
      .el-button {
        height: 40px;
        margin-top: 0.3rem;
        margin-left: 1.8rem;
      }
      .el-button + .el-button {
        margin-left: 10px;
      }
      .input {
        width: 100%;
        height: 0.92rem;
        margin-bottom: 0.38rem;
        position: absolute;
        top: 0;
        left: 0;
        /deep/ .el-input__inner {
          border-radius: 30px;
          height: 0.92rem;
          line-height: 0.92rem;
        }
      }
      .w255 {
        margin: 0 0 0 10px;
      }
      .el-select {
        width: 48%;
        /deep/ .el-input {
          width: 100%;
        }
        /deep/ .el-input__inner {
          height: 40px;
          line-height: 40px;
        }
      }
    }
  }
  .down_list {
    padding: 0;
    box-shadow: none;
    .down-mobile {
      .mobile-item {
        width: 100%;
        color: #555;
        height: 2.27rem;
        padding: 0.29rem;
        font-size: 0.25rem;
        line-height: 0.35rem;
        box-sizing: border-box;
        background: #f9fafc;
        border-radius: 10px;
        margin-bottom: 0.38rem;
        position: relative;
        & > div {
          margin-bottom: 0.19rem;
        }
        .size {
          margin-bottom: 0;
        }
        .title {
          color: #001a33;
          font-size: 0.29rem;
          line-height: 0.4rem;
        }
        .m-btn {
          width: 1.65rem;
          height: 0.54rem;
          font-size: 0.23rem;
          color: #fff;
          text-align: center;
          line-height: 0.54rem;
          background: #1d2379;
          border-radius: 30px;
          position: absolute;
          bottom: 0.29rem;
          margin: 0;
          right: 0.29rem;
        }
      }
    }
  }
}
</style>